<h4 matDialogTitle>Set new password</h4>
<form [formGroup]="newPasswordForm">
  <mat-dialog-content fxLayout="column">
    <p>Please set a new password.</p>
    <mat-form-field>
      <input
        placeholder="Password"
        type="password"
        matInput
        formControlName="password"
        required
      />
    </mat-form-field>

    <mat-form-field>
      <input
        type="password"
        placeholder="Confirm Password"
        matInput
        formControlName="password_confirmed"
        required
      />
      <mat-error
        *ngIf="
          newPasswordForm.controls['password_confirmed'].hasError(
            'passwordMismatch'
          )
        "
      >
        Passwords do not match.
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button
      id="update-password"
      [disabled]="!newPasswordForm.valid"
      mat-raised-button
      color="primary"
      (click)="save()"
    >
      Save
    </button>
  </div>
</form>
